import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import EmptyIcon from "../../../../Shared/EmptyIcon";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import TableFilter from "../../../../Shared/tableFilter";
import { filterType, filterData } from "../../../../../helpers/filterHelper";
import DataGrid, { Column, RemoteOperations, Paging, Pager, MasterDetail } from "devextreme-react/ui/data-grid";
import validaciones from "../../../../../helpers/validaciones";
import { Button } from "devextreme-react";
import { doGetFiltrosEmpresas, doGetEmpresas, doGetEmpresa, openCloseModalEditarEmpresa, setListaEmpresasFiltradas } from "./action";
import DetailEmpresa from "./detailEmpresaDataGrid";
import ModalEditar from "./modalEditar";


class Empresas extends React.PureComponent {
  constructor(props) {
    super(props);

    if (!this.props.filtrosCupos) this.props.dispatch(doGetFiltrosEmpresas());
    this.props.dispatch(doGetEmpresas(null, true));
  }

  handleAdd = () => {
    this.props.dispatch(openCloseModalEditarEmpresa(true, {}, true));
  }

  handleDelete = (e) => {
    //this.props.dispatch(openCloseModalEliminarEmpresa(true, e.data));
  }

  handleFilterChange = (text, filters) => {
    const currentFilters = [...filters];
    let textFormatted = validaciones.formatRut(text, { showDots: false, showHyphen: true });
    if (text){
      currentFilters.push({ column: "CompanyRut", value: { textFormatted, value: textFormatted }, type: filterType.search });
      currentFilters.push({ column: "SelService", value: { text, value: text }, type: filterType.search });
    } 
    const newData = filterData(this.props.listaEmpresas, currentFilters);
    if (currentFilters.length > 0) {
      this.props.dispatch(setListaEmpresasFiltradas(newData));
    } else {
      this.props.dispatch(setListaEmpresasFiltradas(this.props.listaEmpresas));
    }
  }

  handleEdit = (row) => {
    this.props.dispatch(doGetEmpresa(row.data.CompanyRut));
    this.props.dispatch(openCloseModalEditarEmpresa(true, {}, false));
  }

  handleDataEmpresa = (e) => {
    //this.props.dispatch(setEmpresa(e.data));
  }

  render() {
    const { listaEmpresasFiltradas } = this.props;
    return (
      <React.Fragment>
        {this.props.isLoading && <LoadingOverlay />}
        <ModalEditar />
        <TableFilter
          placeholder="Buscar empresa por rut o razón social"
          onChange={this.handleFilterChange}
          filters={this.props.filtrosEmpresas}
          show
          format="#,##0.##"
          buttons={{
            filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
            document: { buttonName: "iconDocument", visible: false, buttonAction: null },
            download: { buttonName: "iconDownload", visible: false, buttonAction: null },
            newItem: {
              buttonName: "custom", visible: true, buttonAction: this.handleAdd, buttonText: "Agregar Empresa",
            },
          }}
        />

        <DataGrid
          dataSource={listaEmpresasFiltradas}
          keyExpr={"CompanyRut"}
          noDataText=""
          className="custom-table"
          showBorders={false}
          showColumnLines={false}
          allowColumnResizing={false}
          columnAutoWidth={false}
          showRowLines={false}
          onRowExpanding={ (e) =>{
            e.component.collapseAll(-1);
          }}
          rowAlternationEnabled
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin Información");
              noDataSpan.appendChild(element);
            }
          }}
        >
          <Column
            alignment="center"
            dataField="CompanyName"
            caption="Empresa"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div> 
                  <div style={{ fontWeight: 'bold' }}>
                    {row.data.CompanyName}
                  </div>
                  <div>
                    {row.data.CompanyRut}
                  </div> 
                </div>
                , element
              );
            }}
          />

          <Column
            alignment="center"
            dataField="SelSegment"
            caption="Afiliados"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <i className="mantenedor-empresa-icon achs-icon"> {row.data.SelService ? 'X' : 'W' } </i>
                , element
              );
            }}
          />

          <Column
            alignment="center"
            dataField="SelSegment"
            caption="Segmento SEL"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div> {row.data.SelSegment == 2 ? 'Gran cliente' : 'PYME' } </div>
                , element
              );
            }}
          />

          <Column
            alignment="center"
            dataField="SelService"
            caption="Servicio SEL"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <i className="mantenedor-empresa-icon achs-icon"> {row.data.SelService ? 'X' : 'W' } </i>
                , element
              );
            }}
          />

          <Column
            alignment="center"
            dataField="HasAgreements"
            caption="Convenios"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <i className="mantenedor-empresa-icon achs-icon"> {row.data.HasAgreements > 0 ? 'X' : 'W' } </i>
                , element
              );
            }}
          />

          <Column
            alignment="center"
            dataField="ApproversQuota"
            caption="Aprobadores"
          />

          <Column
            alignment="center"
            dataField="NoNameLimit"
            caption="Límite sin nombre"
          />

          <Column
            alignment="center"
            dataField="NoNameTime"
            caption="Plazo sin nombre"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div> {row.data.NoNameTime ? row.data.NoNameTime + ' hrs' : 'Sin Información' } </div>
                , element
              );
            }}
          />

          <Column
            caption=""
            alignment="right"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <Button className="slimButton" type="success" text="Editar" onClick={() => this.handleEdit(row)} />
                , element
              );
            }}
          />
          
          <MasterDetail
            enabled={true}
            component={DetailEmpresa}
          />

          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />

          <Paging
            defaultPageSize={10}
          />

          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />

        </DataGrid>

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorEmpresas.isLoading,
  listaEmpresas: state.mantenedorEmpresas.listaEmpresas,
  listaEmpresasFiltradas: state.mantenedorEmpresas.listaEmpresasFiltradas,
  filtrosEmpresas: state.mantenedorEmpresas.filtrosEmpresas,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Empresas);
